var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M49.18,459.02c-2.26,0-4.1-1.84-4.1-4.1v-8.2c0-2.26,1.84-4.1,4.1-4.1s4.1,1.84,4.1,4.1v8.2 C53.28,457.18,51.44,459.02,49.18,459.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M49.18,434.43c-2.26,0-4.1-1.84-4.1-4.1V315.57c0-2.26,1.84-4.1,4.1-4.1s4.1,1.84,4.1,4.1v114.75 C53.28,432.59,51.44,434.43,49.18,434.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M450.82,163.93c-2.26,0-4.1-1.84-4.1-4.1v-8.2c0-2.26,1.84-4.1,4.1-4.1s4.1,1.84,4.1,4.1v8.2 C454.92,162.1,453.08,163.93,450.82,163.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M450.82,295.08c-2.26,0-4.1-1.84-4.1-4.1V176.23c0-2.26,1.84-4.1,4.1-4.1s4.1,1.84,4.1,4.1v114.75 C454.92,293.25,453.08,295.08,450.82,295.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M159.84,135.25H81.97c-1.66,0-3.16-1-3.79-2.53c-0.64-1.53-0.29-3.3,0.89-4.47l77.87-77.87 c1.17-1.17,2.93-1.53,4.47-0.89c1.53,0.63,2.53,2.13,2.53,3.79v77.87C163.93,133.41,162.1,135.25,159.84,135.25z M91.86,127.05 h63.88V63.17L91.86,127.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M397.54,500H102.46c-13.56,0-24.59-11.03-24.59-24.59V131.15c0-1.09,0.43-2.13,1.2-2.9l77.87-77.87 c0.77-0.76,1.81-1.2,2.9-1.2h237.7c13.56,0,24.59,11.03,24.59,24.59v401.64C422.13,488.97,411.1,500,397.54,500z M86.07,132.84 v342.57c0,9.04,7.35,16.39,16.39,16.39h295.08c9.04,0,16.39-7.35,16.39-16.39V73.77c0-9.04-7.35-16.39-16.39-16.39H161.53 L86.07,132.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M122.95,24.59H90.16c-2.26,0-4.1-1.84-4.1-4.1s1.84-4.1,4.1-4.1h32.79c2.26,0,4.1,1.84,4.1,4.1 S125.21,24.59,122.95,24.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M106.56,40.98c-2.26,0-4.1-1.84-4.1-4.1V4.1c0-2.26,1.84-4.1,4.1-4.1c2.26,0,4.1,1.84,4.1,4.1v32.79 C110.66,39.15,108.82,40.98,106.56,40.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M81.97,69.67H49.18c-2.26,0-4.1-1.84-4.1-4.1c0-2.26,1.84-4.1,4.1-4.1h32.79c2.26,0,4.1,1.84,4.1,4.1 C86.07,67.84,84.23,69.67,81.97,69.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M65.57,86.07c-2.26,0-4.1-1.84-4.1-4.1V49.18c0-2.26,1.84-4.1,4.1-4.1c2.26,0,4.1,1.84,4.1,4.1v32.79 C69.67,84.23,67.84,86.07,65.57,86.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M393.44,122.95c-2.26,0-4.1-1.84-4.1-4.1V86.07c0-2.26-1.84-4.1-4.1-4.1h-32.79c-2.26,0-4.1-1.84-4.1-4.1 c0-2.26,1.84-4.1,4.1-4.1h32.79c6.78,0,12.3,5.52,12.3,12.3v32.79C397.54,121.11,395.7,122.95,393.44,122.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M385.25,340.16H114.75c-2.26,0-4.1-1.84-4.1-4.1V172.13c0-2.26,1.84-4.1,4.1-4.1h270.49 c2.26,0,4.1,1.84,4.1,4.1v163.93C389.34,338.33,387.51,340.16,385.25,340.16z M118.85,331.97h262.3V176.23h-262.3V331.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 114.75,
    y: 172.13,
    fill: "#FFD742",
    width: 270.49,
    height: 32.79
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M385.25,209.02H114.75c-2.26,0-4.1-1.84-4.1-4.1v-32.79c0-2.26,1.84-4.1,4.1-4.1h270.49 c2.26,0,4.1,1.84,4.1,4.1v32.79C389.34,207.18,387.51,209.02,385.25,209.02z M118.85,200.82h262.3v-24.59h-262.3V200.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M262.3,340.16c-2.26,0-4.1-1.84-4.1-4.1V172.13c0-2.26,1.84-4.1,4.1-4.1s4.1,1.84,4.1,4.1v163.93 C266.39,338.33,264.56,340.16,262.3,340.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M303.28,340.16c-2.26,0-4.1-1.84-4.1-4.1V172.13c0-2.26,1.84-4.1,4.1-4.1s4.1,1.84,4.1,4.1v163.93 C307.38,338.33,305.54,340.16,303.28,340.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.28,
    y: 336.07,
    fill: "#F05555",
    width: 81.97,
    height: 32.79
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M385.25,372.95h-81.97c-2.26,0-4.1-1.84-4.1-4.1v-32.79c0-2.26,1.84-4.1,4.1-4.1h81.97 c2.26,0,4.1,1.84,4.1,4.1v32.79C389.34,371.11,387.51,372.95,385.25,372.95z M307.38,364.75h73.77v-24.59h-73.77V364.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M213.11,397.54h-98.36c-2.26,0-4.1-1.84-4.1-4.1s1.84-4.1,4.1-4.1h98.36c2.26,0,4.1,1.84,4.1,4.1 S215.38,397.54,213.11,397.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M163.93,422.13h-49.18c-2.26,0-4.1-1.84-4.1-4.1c0-2.26,1.84-4.1,4.1-4.1h49.18c2.26,0,4.1,1.84,4.1,4.1 C168.03,420.3,166.2,422.13,163.93,422.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 209.02,
    y: 98.36,
    fill: "#56C0EE",
    width: 81.97,
    height: 32.79
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#273339",
    d: "M290.98,135.25h-81.97c-2.26,0-4.1-1.84-4.1-4.1V98.36c0-2.26,1.84-4.1,4.1-4.1h81.97 c2.26,0,4.1,1.84,4.1,4.1v32.79C295.08,133.41,293.25,135.25,290.98,135.25z M213.11,127.05h73.77v-24.59h-73.77V127.05z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.fd9bb146ed1a7bdf79ca42c8c1bddde4.svg";
export { ForwardRef as ReactComponent };